import { ValidatorInterface } from "./ValidatorInterface";

export class OrValidator {
	private readonly validators: ValidatorInterface[];

	constructor( validators: ValidatorInterface[] ) {
		this.validators = validators;
	}

	getMessage(): string {
		return this.validators.map( ( validator: ValidatorInterface ) => validator.getMessage() ).join( ` ${window.measurementSelectorVariables.i18n.or} ` );
	}

	isValid(): boolean {
		return this.validators.some( ( validator: ValidatorInterface ) => validator.isValid() );
	}

}
